import { ButtonGroup } from "@overmap-ai/blocks"
import { memo, type ReactNode } from "react"

import { AIButton } from "../../components/Buttons/AIButton"
import { LeftSlideOutButton } from "../../components/Buttons/LeftSlideOutButton"
import { OutboxButton } from "../../components/Buttons/OutboxButton"
import { RightSlideOutButton } from "../../components/Buttons/RightSlideOutButton"
import { TopBarContainer } from "../../components/Containers/TopBarContainer"

export interface BaseTopBarProps {
	leftContent?: ReactNode
	rightContent?: ReactNode
	showLeftSlideOutButton?: boolean
	showRightSlideOutButton?: boolean
	showAIButton?: boolean
	showOutboxOrRefreshButton?: boolean
}

export const BaseTopBar = memo<BaseTopBarProps>((props) => {
	const {
		leftContent,
		rightContent,
		showLeftSlideOutButton = true,
		showRightSlideOutButton = false,
		showAIButton = true,
		showOutboxOrRefreshButton = true,
	} = props

	return (
		<TopBarContainer>
			<ButtonGroup variant="ghost" accentColor="base" className="flex grow gap-2">
				<div className="flex grow items-center gap-2">
					{showLeftSlideOutButton && <LeftSlideOutButton />}
					{leftContent}
				</div>
				<div className="flex items-center justify-end gap-2">
					{rightContent}
					{showOutboxOrRefreshButton && <OutboxButton />}
					{showAIButton && <AIButton />}
					{showRightSlideOutButton && <RightSlideOutButton />}
				</div>
			</ButtonGroup>
		</TopBarContainer>
	)
})
BaseTopBar.displayName = "BaseTopBar"
